interface TFBadgeProps {
  title: string;
  style?: "yellow" | "blue" | "green" | "purple" | "orange" | "gray";
  className?: string;
}

const TFBadge = ({ title, style = "gray", className = "" }: TFBadgeProps) => {
  const baseClasses =
    "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium";

  const styleClasses = {
    yellow: "bg-yellow-100 text-yellow-800",
    blue: "bg-blue-100 text-blue-800",
    green: "bg-green-100 text-green-800",
    purple: "bg-purple-100 text-purple-800",
    orange: "bg-orange-100 text-orange-800",
    gray: "bg-gray-100 text-gray-800",
  };

  return (
    <span className={`${baseClasses} ${styleClasses[style]} ${className}`}>
      {title}
    </span>
  );
};

export default TFBadge;
